export const HeaderChatFilterOption = {
  ALL: 'all',
  MENTIONS: 'mentions',
};

export const HEADER_CHAT_TAB_OPTIONS = [
  { value: HeaderChatFilterOption.ALL, label: 'All' },
  { value: HeaderChatFilterOption.MENTIONS, label: 'Mentions' },
];

export const HEADER_CHAT_MENTIONS_EMPTY_LABEL =
  "You haven't been mentioned in any conversation yet.";

export const HEADER_CHAT_INBOX_EMPTY_LABEL =
  'You have no conversations yet. Chats from your loans will appear here.';

export const HEADER_CHAT_SEARCH_EMPTY_LABEL_PREFIX = 'No conversations match ';

export const HEADER_CHAT_MENTION_PREVIEW_MAX_CHARS = 140;

export const HEADER_CHAT_SEARCH_PLACEHOLDER = 'Search conversations';

export const HEADER_CHAT_RECENT_LIMIT = 8;

export const HEADER_CHAT_VIEW_ALL_LABEL = 'View all in Messages';

export const HeaderChatSection = {
  PINNED: 'pinned',
  MENTIONED: 'mentioned',
  UNREAD: 'unread',
  RECENT: 'recent',
};
